export const DEFAULT_LANGUAGE = 'vn';
export const CZECH_LANGUAGE = 'cz';
export const DEFAULT_PASSWORD_TYPE = 'password';
export const GOOGLE_CLIENT_ID = '992606510714-0l2o0iltcum8ec224p70nm1779i81sf7.apps.googleusercontent.com';
export const FACEBOOK_APP_ID = '933980429523534';
export const APPLE_CLIENT_ID = 'cz.prahanoi.web';
export const BANK_ACCOUNT = '1883333444O/0600';
export const WEB_NAME = 'Prahanoi';
